import { FetchDataResponse, NextType } from '../types';

export enum DeliveryType {
	WS = 1,
	HTTP = 2,
	FILE = 3,
}

export interface CreateDeliveryRequest {
	name: string;
	type: DeliveryType;
	objects: string[];
}

export interface Delivery extends CreateDeliveryRequest {
	delivery: string;
}

export interface GetListDeliveriesResponse extends NextType {
	deliveries: Delivery[];
}

export type ListDeliveriesResponse =
	FetchDataResponse<GetListDeliveriesResponse>;
export type GetDeliveryResponse = FetchDataResponse<Delivery>;
